import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import './App.css';
import HeaderNavbar from './component/HeaderNavbar';
import BackgroundImage from './component/BackgroundImage';
import CarPage from "./component/CarPage";
import CarDetails from './component/CarDetails.js';
import Login from './component/Login';
import Signup from "./component/Signup";
import ResetPassword from './component/ResetPassword.js';
import PostCar from './component/PostCar';
import OrderConfirmationPage from './component/pages/OrderConfirmationPage';
import ImportersExporters from './component/pages/ImportersExporters.js';
import AutomotiveEngineers from './component/pages/AutomotiveEngineers.js';
import RepairServices from './component/pages/RepairServices.js';
import SpareParts from './component/pages/SpareParts.js';
import CarsListPage from './component/pages/CarsListPage';
import Footer from './component/Footer';
import AboutUs from './component/pages/AboutUs.js';
import PrivacyPolicy from './component/pages/PrivacyPolicy.js'; 
import TermsAndConditions from './component/pages/TermsAndConditions.js'; 

function App() {
  const isAuthenticated = localStorage.getItem("user");

  // Hook to know where we are in the app
  const location = useLocation();

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}> 
      <HeaderNavbar />

      {/* Show background image only on home page */}
      {location.pathname === "/" && <BackgroundImage />}

      <div style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<CarPage />} />
          {/* <Route path="/cars/:id" element={<CarDetails />} /> */}
          <Route path="/cars/:slug" element={<CarDetails />} />
          <Route path="/cars" element={<CarsListPage />} /> 
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/reset" element={<ResetPassword />} />
          <Route
            path="/post"
            element={isAuthenticated ? <PostCar /> : <Navigate to="/login" />}
          />
          <Route path="/order/:orderId" element={<OrderConfirmationPage />} />
          <Route path="/importers-exporters" element={<ImportersExporters />} />
          <Route path="/automotive-engineers" element={<AutomotiveEngineers />} />
          <Route path="/repair-services" element={<RepairServices />} />
          <Route path="/spare-parts" element={<SpareParts />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        </Routes>
      </div>
    
      <Footer />
    </div>
  );
}

// Wrap App with Router & GoogleOAuthProvider in one place
export default function AppWrapper() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <Router>
        <App />
      </Router>
    </GoogleOAuthProvider>
  );
}
